<template>
	<div class="banner-goodjob card-body">
		<h2 class="h2-title">{{title}}</h2>
		<div class="banner-goodjob-description" v-html="description">
		</div>
	</div>
</template>
<style lang="css">
	.banner-goodjob {
		position: relative;
		background-image: url("https://storage.yandexcloud.net/proektoria-education/static/images/goodjob-bottom.svg");
		background-repeat: no-repeat;
		background-size: 100%;
		background-position: bottom;
	}
	.banner-goodjob:after {
		content: '';
		display: block;
		position: absolute;
		right: 0;
		bottom: 0;
		width: 144px;
		height: 217px;
		background: url("https://storage.yandexcloud.net/proektoria-education/static/images/goodjob-person.png") no-repeat;
		background-size: 100%;
	}
	.banner-goodjob-description {
		min-height: 90px;
		padding-right: 150px;
	}
	@media (max-width: 768px) {
		.banner-goodjob-description {
			padding-right: 0;
			padding-bottom: 220px;
		}
	}
</style>
<script>
	export default {
		props: {
			title: {
				type: String,
				default: '',
				required: true,
			},
			description: {
				type: String,
				default: '',
				required: true
			}
		}
	}
</script>
